import styles from './PromoSection.module.scss';

const PromoSection = () => {
  return (
    <div className={styles.promoSection}>
      <div className={styles.promoBanner}>
        <p>
          Hãy sử dụng mã khuyến mãi <span className={styles.highlight}>VNREBATES</span> để được{' '}
          <span className={styles.highlight}>giảm 30%</span> lên đến{' '}
          <span className={styles.highlight}>250 USD</span>.
        </p>
      </div>
    </div>
  );
};

export default PromoSection;
